exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autosuggest-list{border:1px solid var(--primary);border-radius:3px;margin-top:2px;position:absolute;width:100%;z-index:999;background:#fff}.autosuggest-list li{width:100%;border-bottom:1px solid var(--primary);cursor:pointer;padding:7px}.autosuggest-list li:last-child{border-bottom:none}.autosuggest-list li:hover{background:var(--primary);color:#fff}", ""]);

// exports
